import { useMemo, useRef } from "react"

type Callbacks = Record<string, (...args: never[]) => unknown>

/**
 * The same functions on every render, each calling the latest version passed in, so a context
 * holding them doesn't change (and re-render its consumers) when the data they read changes.
 */
const useStableCallbacks = <T extends Callbacks>(callbacks: T): T => {
  const latest = useRef(callbacks)
  latest.current = callbacks

  return useMemo(() => Object.fromEntries(Object.keys(callbacks).map((name) => [
    name,
    (...args: never[]) => latest.current[name](...args),
  ])) as T, [])
}

export default useStableCallbacks
